export const API = "/api";
export const SLASH = "/";
